<script setup lang="ts">
import { Incident } from '@collector/sportsapi-client'
import { useEventStatusName } from '@desktop/views/Relation/composables/useEventStatusName'

interface Props {
  incident: Incident
  isDeleted?: boolean
}

const props = defineProps<Props>()

// composables
const { getEventStatusAcronym, getEventStatusName } = useEventStatusName()

// data
const eventStatusName =
  getEventStatusAcronym(props.incident.status_id) ||
  getEventStatusName(props.incident.status_id)
</script>

<template>
  <div
    class="text-2xs"
    :class="{
      'text-neutral-dark-3/40': isDeleted,
    }"
  >
    {{ eventStatusName }}
  </div>
</template>
